import { createApi } from './api';
export function create(_ref) {
  let {
    httpClient
  } = _ref;
  const {
    getPropertyById
  } = createApi(httpClient);
  return {
    getPropertyById
  };
}